import type { RouteRecordRaw } from 'vue-router'

const settingsRoutes: RouteRecordRaw = {
  path: '/settings',
  name: 'settings',
  meta: { layout: 'DashboardLayout', requiresAuth: true, title: 'common.user.settings' },
  component: () => import('@/pages/settings/SettingsPage.vue'),
}

export default settingsRoutes
